import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NGXLogger } from 'ngx-logger';

/* import { Level as LoggerLevel } from 'angular2-logger/app/core/level';
import { Logger, Options as LoggerOptions } from 'angular2-logger/app/core/logger'; */

/**
 * DOSLoggerService offers a sub-list of capabilities,
 * this can be enhanced later to log messages/trace to sever
 */
@Injectable()
export class TCCPLoggerService {

    constructor(private logger: NGXLogger) {
    }

    /**
     * Log Start Method
     * @param module - name of the module e.g. Regulatory or PPSMLR
     * @param method - name of the method e.g. createRegulatoryCode
     * @param message - actual message that to be logged.
     * @param args  - argument should be the input param for the method
     */
    public logMethodStart(module: string, method: string, message: string, args: any): void {
        this.logger.debug(this.getCurrentDate() + ' TCCP Log: Module Name:' +
            module + '----Method:' + method + '----Message:' + message + '----Arguments:' + args);
    }

    /**
     * logMethodFlow - Need to Execute in flow of every method.
     * @param module
     * @param method
     * @param message
     * @param args
     */
    public logMethodFlow(module: string, method: string, message: string, args: any): void {
        this.logger.debug(this.getCurrentDate() + ' TCCP Log: Module Name:' +
            module + '----Method:' + method + '----Message:' + message + '----Arguments:' + args);
    }

    /**
     * logMethodEnd - Need to Execute at End of every method.
     * @param module - name of the module e.g. Regulatory or PPSMLR
     * @param method - name of the method e.g. createRegulatoryCode
     * @param message - actual message that to be logged.
     * @param args  - argument should be the out param/return value of the method
     */
    public logMethodEnd(module: string, method: string, message: string, args: any): void {
        this.logger.debug(this.getCurrentDate() + ' TCCP Log: Module Name:' +
            module + '----Method:' + method + '----Message:' + message + '----Arguments:' + args);
    }

    /**
     * log Events - Need to Execute at End of every method.
     * @param module - name of the module e.g. Regulatory or PPSMLR
     * @param method - name of the method e.g. createRegulatoryCode
     * @param message - actual message that to be logged e.g. 'Created Regulatory group '.
     * @param args - Any argument that needs be passed for the message e.g. 'NTHSA'.
     */
    public logEvent(module: string, method: string, message: string, args: any): void {
        this.logger.debug(this.getCurrentDate() + ' TCCP Log: Module Name:' +
            module + '----Method:' + method + '----Message:' + message + '----Arguments:' + args);
    }

    /**
     This method can be called inside the catch block. This methods takes
     * variable number of arguments, arguments could be Local method variables,
     * Instance variables when the exception happened. The variables should have
     * overridden the toString() method.
     *
     * @param module - name of the module e.g. Regulatory or PPSMLR
     * @param method - name of the method e.g. createRegulatoryCode
     * @param message - actual message that to be logged e.g. 'Exception occurred while creating Group '.
     * @param args  - argument should be the input param for the method
     * @param error - Actual error stack.
     */
    public logException(module: string, method: string, message: string, args: any, error: Error): void {
        this.logger.error(this.getCurrentDate() + ' TCCP Log: Module Name:' +
            module + '----Method:' + method + '----Message:' + message + '----Arguments:' + JSON.stringify(args) + '----Error:' + error);
    }

    /**
     * Log Informational - Need to Execute at End of every method.
     * @param module - name of the module e.g. Regulatory or PPSMLR
     * @param method - name of the method e.g. createRegulatoryCode
     * @param message - actual message that to be logged e.g. 'Created Regulatory group '.
     * @param args - Any argument that needs be passed for the message e.g. 'NTHSA'.
     */
    public logInfo(module: string, method: string, message: string, args: any): void {
        this.logger.info(this.getCurrentDate() + ' TCCP Log: Module Name:' +
            module + '----Method:' + method + '----Message:' + message + '----Arguments:' + args);
    }

    /**
     * Returns current date
     */
    private getCurrentDate = (): any => {
        const datePipe = new DatePipe('en-US');
        return datePipe.transform(Date.now(), 'MMM-dd-yyyy @ h:mm a');
    }
}
